import React from 'react';
import logoImage from '../images/logo.png'; // Update this path to where your logo PNG is stored

const Logo = ({ className = '' }) => {
  return (
    <img 
      src={logoImage} 
      alt="Logo" 
      className={`logo ${className}`}
    />
  );
};

export default Logo; 